require('../vendor/jquery.validate.min.js');
import { getLang } from '../utils/helpers.js';
require('../utils/forms.js');
require('../vendor/select2.min');

var lang = getLang();
var $popupWrapper = $('.popup-wrapper'),
    $formPopup = $('.popup-career-form'),
    $popupMessage = $('.popup-career-succes'),
    $vacancyResponseForm = $('.js-vacancy-response-form');

var requestData = {
    type: $('.career__vacancy-block_active').data('vacancies-type'),
};

var validator = $vacancyResponseForm.validate({
    lang: lang,
    debug: false,
    errorClass: 'form-error',
    errorElement: 'span',
    ignore: '',
    rules: {
      name: {
        required: true,
        // customName: true,
      },
      phone: {
        required: true,
        phone: true,
        normalizer: function(value){
          return value.replace(/[\s\-\(\)]/g, '');
        },
      },
      address: {
        required: true,
        // phone: true,
        // normalizer: function(value){
        //   return value.replace(/[\s\-\(\)]/g, '');
        // },
      },
    },
    // ignore: '.select2-search__field',
    errorPlacement: function (error, element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().append(error);
        } else {
            $(element).prev().append(error);
        }
    },
    highlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().addClass('_error');
        } else {
            $(element).addClass('_error');
            $(element).prev().addClass('_error');
        }
        
        
    },
    unhighlight: function(element) {
        if($(element).is(':radio')) {
            $(element).parent().parent().prev().removeClass('_error');
        } else {
            $(element).removeClass('_error');
            $(element).prev().removeClass('_error');
        }
    }
});

$vacancyResponseForm.submit(function(e){
    let $form = $(this);
    if(validator.valid()){
        $.post(
          $form.attr('action'),
          $form.serialize(),
          function(data){
            if (data.error != true){
                $('.feedback-modal').show();
                $('.modal-cnt').fadeIn();
                $form[0].reset();
                validator.reset();
                $formPopup.fadeOut(500);
                $popupMessage.fadeIn(500);
                // $(window).scrollTop(0);
            }
          }
        );
    }
    return false;
});

function updateVacancies() {
    $('.vacancies-wrapper').html('');
    if(lang=='ru') {
        var url = '/get-vacancies/';
    } else {
        var url = '/' + lang + '/get-vacancies/';
    }
    $.get(
        url,
        requestData,
        function(data){
            if (data.error == false){
                if(data.template) {
                    $('.vacancies-wrapper').html(data.template);
                }
            }
        }    
    );
}

$('.js-vacancies-type').click(function(){
    let $el = $(this);
    if(lang=='ru') {
        var url = '/get-vacancies-type/';
    } else {
        var url = '/' + lang + '/get-vacancies-type/';
    }
    $.get(
        url,
        {
            vacancies_type: $el.data('vacancies-type'),
        },
        function(data){
            if (data.error == false){
                if(data.showCategories) {
                    $('.career-form-categories').show();
                } else {
                    $('.career-form-categories').hide();
                }
                requestData.type = $el.data('vacancies-type');
                $('.career__vacancy-block').removeClass('career__vacancy-block_active');
                $el.addClass('career__vacancy-block_active');
                if(data.template) {
                    $('.career-wrapper').html(data.template);
                    $('.js-select-search').select2({
                        minimumResultsForSearch: 20,
                        dropdownCssClass: 'select-dropdown select-dropdown_filter'
                    });
                    $('.js-select-no-search').select2({
                        minimumResultsForSearch: -1,
                        dropdownCssClass: 'select-dropdown select-dropdown_filter'
                    });

                    $('.career-slider-success').slick({
                        speed: 1000,
                        infinite: false
                    });

                    $('._slider_nums').each(function () {
                        var t = $(this),
                            numSlides = t.find('.slider__slide'),
                            numLength = numSlides.length;

                        numSlides.each(function () {
                            var t = $(this),
                                index = t.index() + 1;
                            t.append('<div class="e-slider-num"><span>0' + index + '</span>| 0' + numLength + '</div>');
                        });
                    });
                }
            }
        }    
    );
})

$('body').on('change', '.js-select-department', function(){
    if($(this).val()) {
        requestData.department = $(this).val();
    } else {
        delete requestData.department;
    }
    updateVacancies();
});

$('body').on('change', '.js-select-category', function(){
    if($(this).val()) {
        requestData.category = $(this).val();
    } else {
        delete requestData.category;
    }
    updateVacancies();
});

$('body').on('change', '.js-select-region', function(){
    if($(this).val()) {
        requestData.region = $(this).val();
    } else {
        delete requestData.region;
    }
    updateVacancies();
});

$('body').on('click', '.js-show-vacancies', function(){
    $('.accordion__item').removeClass('accordion__item_hidden');
    $(this).remove();
});

$('.js-expand-text-btn').click(function(){
    $('.career__expand-text').slideToggle();
    $(this).remove();
});

$('body').on('click', '._popup-open_career', function () {
    $formPopup.fadeIn(500);
    $popupWrapper.fadeIn(300);
    // $(window).scrollTop(0);

    $('.vacancy-input').val($(this).data('vacancy'));
    $('.vacancy-label').text($(this).data('vacancy-name'));
});


// WEBPACK FOOTER //
// ./js/pages/career.js